/// <reference types="@angular/localize" />

import { registerLocaleData } from '@angular/common';
import {
  provideHttpClient,
  withInterceptorsFromDi,
  withJsonpSupport,
} from '@angular/common/http';
import localeJa from '@angular/common/locales/ja';
import localeKo from '@angular/common/locales/ko';
import localeZh from '@angular/common/locales/zh';
import {
  ApplicationConfig,
  ErrorHandler,
  Provider,
  enableProdMode,
} from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
  RouteReuseStrategy,
  provideRouter,
  withInMemoryScrolling,
} from '@angular/router';
import { provideTransloco } from '@ngneat/transloco';
import { createErrorHandler } from '@sentry/angular';
import { GALLERY_CONFIG, GalleryConfig } from 'ng-gallery';
import { LIGHTBOX_CONFIG, LightboxConfig } from 'ng-gallery/lightbox';
import { appRoutes } from './app/app-routing';
import { AppComponent } from './app/app.component';
import { httpInterceptorProviders } from './app/core/http-interceptors';
import { AppRouteReuseStrategy } from './app/core/reuse-strategy';
import { initSentry } from './app/core/sentry';
import { translocoOptions } from './app/transloco-options';
import { environment } from './environments/environment';


if (environment.name != 'local') {
  enableProdMode();
}

initSentry();

registerLocaleData(localeJa);
registerLocaleData(localeZh);
registerLocaleData(localeKo);

function stagingAndProdProvider(): Provider[] {
  if (environment.name === 'local') {
    return [];
  }
  return [
    {provide: ErrorHandler, useValue: createErrorHandler()},
  ];
}

const config: ApplicationConfig = {
  providers: [
    ...stagingAndProdProvider(),
    {
      provide: LIGHTBOX_CONFIG,
      useValue: <LightboxConfig>{
        keyboardShortcuts: false,
        exitAnimationTime: 1000
      }
    },
    {
      provide: GALLERY_CONFIG,
      useValue: <GalleryConfig>{
        autoHeight: true,
        imageSize: 'cover'
      }
    },
    {provide: RouteReuseStrategy, useClass: AppRouteReuseStrategy},
    provideRouter(appRoutes, withInMemoryScrolling({
      scrollPositionRestoration: 'disabled',  // Custom scroller is used in app.component.ts for backwards nav is more accurate for our use case
      anchorScrolling: 'enabled',
    })),
    httpInterceptorProviders,
    provideHttpClient(withJsonpSupport(), withInterceptorsFromDi()),
    provideTransloco(translocoOptions),
    provideAnimations(),
  ],
};

bootstrapApplication(AppComponent, config).catch((err) => console.error(err));
